// @flow
import React from 'react'
import styled from 'styled-components'
import { media } from 'src/theme/style-utils'

const StyledLogo = styled.svg`
  width: 40px;
  height: 40px;

  ${media.tablet`
    width: 42px;
    height: 48px;
  `};
`

const StyledG = styled.g`
  fill: ${props => props.theme.darker};
`

const Logo = () => {
  return (
    <StyledLogo viewBox="0 0 60 60">
      <StyledG>
        <path
          fill="#082622"
          d="M18.398 43.755C14.49 40.455 12 35.52 12 30a17.9 17.9 0 0 1 2.37-8.925c4.162 1.005 7.613 3.727 9.075 7.68 1.973 5.317-.24 11.287-5.047 15zm18.067-17.783L24.577 47.168c1.718.54 3.54.833 5.438.833 9.097 0 16.627-6.742 17.843-15.502-.218-.195-.45-.383-.683-.57-3.022-2.416-6.6-4.253-10.17-5.738l-.54-.218zm-4.41 4.493l2.97-5.302.712-1.268 1.35.547.548.226h.015c3.308 1.38 6.105 2.835 8.468 4.432l1.89-.18C47.444 19.485 39.608 12 30.015 12c-2.355 0-4.598.45-6.66 1.275L30.9 30.578l1.155-.113z"
        />
      </StyledG>
    </StyledLogo>
  )
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Icons/Logo.js